module.exports = "<div [class]=\"class\">\r\n  <p class=\"ion-no-margin ion-no-padding\">\r\n    <ng-content></ng-content>\r\n  </p>\r\n</div>"